const keys = {
    "themoviedb": "19f84e11932abbc79e6d83f82d6d1045",
    "youtube": "AIzaSyAHhKpK0FEPrLfDQcDqWKyPkurHWrhslEg"
}

export { keys }